export default __webpack_public_path__ + "static/media/AKM_8.39104a6f.png";